export default "__VITE_ASSET__K5Z4iwlI__"